"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var playlist_1 = require("../../selectors/playlist");
var regeneratePlaylist_1 = __importDefault(require("../generation/regeneratePlaylist"));
function resetTimings() {
    var action = function (dispatch, getState) {
        if ((0, playlist_1.selectSafeSwitchZone)(getState())) {
            dispatch({ type: resetTimings.type });
            dispatch((0, regeneratePlaylist_1.default)());
        }
    };
    action.type = resetTimings.type;
    return action;
}
resetTimings.type = "resetTimings";
exports.default = resetTimings;
//# sourceMappingURL=resetPlayerTimings.js.map